import { fromJS } from 'immutable';
import { getViewInitialState } from 'src/store/view/reducer';
import { addQueryParam } from 'src/utils/uriUtils';
import {
  QUERY_MOBILE_APP_ROOM_OFFERS,
  TOGGLE_SHORT_INFO,
  SHOW_PAGE,
  SET_SEARCH_TYPE,
} from '../constants/view';

import { INIT_APP } from '../../../../store/view/constants';
import { HOTEL_MOBILE_PAGES } from '../../constants';

const initialState = fromJS(getViewInitialState());

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case INIT_APP:
      return state.set('app', payload.appName);
    case TOGGLE_SHORT_INFO:
      return state.set('isShortInfoClamped', !state.get('isShortInfoClamped'));
    case SHOW_PAGE:
      if (payload === HOTEL_MOBILE_PAGES.SEARCHER) {
        addQueryParam(QUERY_MOBILE_APP_ROOM_OFFERS, 'true');
      } else {
        // костыль нужный чтобы ссылка обновилась (без этого url не меняется)
        setTimeout(() => {
          addQueryParam(QUERY_MOBILE_APP_ROOM_OFFERS, 'false');
        }, 100);
      }
      return state.set('page', payload);
    case SET_SEARCH_TYPE: {
      return state.set('searchType', payload);
    }
    default:
      return state;
  }
}
